import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BAREMO, DOMINO_TEST_DATA } from 'src/app/helpers/domino_data';
import { Domino } from 'src/app/models/domino_models';
import { DominoService } from 'src/app/services/domino.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

declare var $:any;


@Component({
  selector: 'app-domino',
  templateUrl: './domino.component.html',
  styleUrls: ['./domino.component.css']
})
export class DominoComponent implements OnInit {

  @ViewChild('instructions') instructions: ElementRef;


  public NUMBERS = [0,1,2,3,4,5,6];

  public index;
  public texts;
  public testData;
  public questions: Domino[];
  public actualGroup: Domino[] = [];

  public simData: Domino[] = [];

  public simQuestions = [];
  public isSim = true;
  public formModel = {};

  public photoTaked = false;
  public trigger = false;
  public instructionsReaded = false;

  public actualPage = 1

  public responses: string[][] = []
  public testResponses: string[][] = []

  public directScore: number = 0
  public naturalScore: number = 5
  public startTimer: boolean = false

  constructor(
    private dominoService: DominoService, 
    private router: Router, 
    private testService: TestService
  ) { }

  initResponses(){
    for (let r of this.simData){
      this.testResponses.push(['0', '0'])
      this.testResponses[0] = ['1', '3']
      this.testResponses[1] = ['5', '2']
    }

    for (let r of this.questions){
      this.responses.push(['0', '0'])
    }
  }

  ngOnInit(): void {
    this.testData = this.testService.selectedTestData;
    


      
    this.questions = this.dominoService.getQuestions();

    this.actualGroup = this.questions.slice((this.actualPage - 1) * 6, this.actualPage * 6);
      
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.simData = DOMINO_TEST_DATA;
    this.initResponses();
  }

  reload(){
    location.reload()
  }

  ngAfterViewInit(){

    if (this.testData.form){
      $('#formModal').modal('show');
    }
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.dominoInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    
  }

  endSim(){

    if (this.testResponses[2][0] != '4' || this.testResponses[2][1] != '6'){
      return Swal.fire({
        text: 'El resultado de la pregunta C es incorrecto',
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }

    if (this.testResponses[3][0] != '1' || this.testResponses[3][1] != '0'){
      return Swal.fire({
        text: 'El resultado de la pregunta D es incorrecto',
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    }

    return Swal.fire({
      text: 'El resultado de la simulación es correcto',
      icon: 'success',
      confirmButtonText: 'Comenzar prueba'
    }).then(()=>{
      this.isSim = false;
      this.startTest();
    })

  }

  startTest(){
    this.testService.testStarted = true;

    this.startTimer = true;
    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
  }

  sendForm(){
    let obj = {
      _id:this.testService.selectedTestData._id,
      formData:this.formModel
    }
    this.testService.updateTest(obj).subscribe(
      resp=>{
        $('#formModal').modal('hide');
      },
      err=>console.log(err)
    );
  }

  endTest(){
    this.trigger = !this.trigger;
    this.convertScore();
    Swal.fire({
      text:'Has concluido esta evaluación. Agradecemos tu participación',
      icon:'success',
      confirmButtonText:'Salir'
    });
    $("#myModal").modal("hide");
    this.dominoService.createReport(this.directScore, this.naturalScore, this.responses).subscribe(
      res=>{
        var testData = this.testService.selectedTestData;
        let obj = {
          isCompleted:true,
          reportId:res._id,
          completeDate:Date.now(),
          _id:testData._id,
          evaluatedName:testData.evaluatedName,
          client:testData.client,
          type:testData.type
        }
        testData.isCompleted = true;
        testData.reportId = res._id;
        testData.completeDate = Date.now();
        this.testService.updateTest(obj).subscribe(
          r=>{
            this.router.navigateByUrl('dashboard/requestedTests');
          },
          e=>console.log(e)
        );
      },
      err=> console.log(err)
    )
  }

  nextPage(){
    if (this.actualPage < 8){
      this.actualPage++;
      this.actualGroup = this.questions.slice((this.actualPage - 1) * 6, this.actualPage * 6);
    }else{
      this.endTest()
    }
  }

  convertScore(){

    let baremos = BAREMO;
    this.directScore = 0;
    for (let i = 0; i < this.responses.length; i++){
      let r = this.responses[i];
      let correct = this.questions[i].correctValues;
      if (r[0] == correct[0] && r[1] == correct[1]){
        this.directScore++;
      }
    }
    this.naturalScore = 0;
    for (let i = 0; i < baremos.length - 1; i++){
      if (baremos[i].value == this.directScore){
        this.naturalScore = baremos[i].percentil;
      }else{
        if (this.directScore > baremos[i].value && this.directScore < baremos[i + 1].value){
          if (baremos[i + 1].percentil >= 50){
            this.naturalScore = baremos[i + 1].percentil;
          }else{
            this.naturalScore = baremos[i].percentil;
          }
        }
      }
    }
  }

  timeInSeconds(seconds: number){
    if (seconds == 600){
      Swal.fire({
        text: 'Le quedan 20 minutos para finalizar',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        backdrop: false,
      })
    }
    if (seconds == 1200){
      Swal.fire({
        text: 'Le quedan 10 minutos para finalizar',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        backdrop: false,
      })
    }
    if (seconds == 1500){
      Swal.fire({
        text: 'Le quedan 5 minutos para finalizar. Tendrá una tolerancia de 15 minutos.',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        backdrop: false,
      })
    }
    if (seconds == 2700){
      this.endTest()
    }
  }

}
